<template>
  <a href="/" class="no-underline">
    <el-row>
      <span class="img-header"
        ><el-image style="width: 24px; height: 24px" :src="url" :fit="fit"
      /></span>
      <span class="img-header">唯奥衡卓</span>
    </el-row>
  </a>
  <div class="content-header">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <RouterLink to="/guide">指南</RouterLink>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <RouterLink to="/module">模块</RouterLink>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <RouterLink to="/resource">技术</RouterLink>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <RouterLink to="/purchase">购买</RouterLink>
        </el-breadcrumb-item>
        <el-breadcrumb-item></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
import { ArrowDown } from "@element-plus/icons-vue";
export default {
  data() {
    return {
      url: require("@/assets/png/Logo.png"),
      fit: "fill",
      ArrowDown,
    };
  },
};
</script>
<style>
.img-header {
  display: flex;
  align-items: center;
  padding-top: 1px;
  padding-left: 5px;
  font-weight: 800;
  color: black;
}
a.no-underline {
  text-decoration: none;
}
.content-header {
  width: 340px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
  float: right;
  padding-top:10px;
}
</style>
